import { jsx as _jsx } from "react/jsx-runtime";
import "./bootstrap";
import { NativeBaseProvider } from "native-base";
import { ThemeProvider as StyledComponentsProvider } from "styled-components";
import theme from "./theme";
const UiProvider = ({ children }) => (_jsx(NativeBaseProvider, Object.assign({ theme: theme, config: {
        strictMode: "error",
    } }, { children: _jsx(StyledComponentsProvider, Object.assign({ theme: theme }, { children: children })) })));
export default UiProvider;
